export default __webpack_public_path__ + "bell-musical-tool.png";